<template>
   <div>
    <nav-bar titleText="营业资质" fontColor="#000000" @goBack="goBack" :whiteBack="false" :boxShadow="'0px 0px 0px 0px'" :bg="'#fff'"></nav-bar>
    <div class="qualifications-body">
        <div class="shade-watermark"></div>
        <div v-for="(item, index) in supermarketQualificationsList" :key="index" :class="index==0?'qualifications-content qualifications-contents':'qualifications-content'">
            <p class="qualifications-title">{{item.certificate_name}}</p>
            <img :src="item.image[0]" alt="" width="100%" @click="magnify(index)"/>
        </div>
      <div class="tips" :style="supermarketQualificationsList.length>0?'':'padding-top:50px;'">注：根据国家工商局《网络交易管理办法》要求对入驻商家营业执照信息进行公示。以上营业资质信息照片均由商家提供，信息以证件照所示为主。</div>
    </div>
    <van-image-preview v-model="previewshow" :images="images" :startPosition="startPosition" @change="onChange" class="certifi-van-image">
        <template v-slot:index><span class="title">{{typename[index]}}</span><span class="page"><label>{{index+1}}</label>/{{images.length}}</span></template>
        <template v-slot:cover>
            <div class="shade-watermarks"></div>
            <div class="image-preview-close-btn">
                <span class="close" @click="previewshow=false">✖</span>
            </div>
        </template>
    </van-image-preview>
  </div>
</template>

<script>
import navBar from './components/navBar'
export default {
    components:{
    navBar
  },
    data(){
        return{
            images: [],
            startPosition:0,
            typename:[],
            index: 0,
            previewstartPositionindex: 0,
            previewshow: false,
            supermarketQualificationsList:[]
        }
    },
    created(){
        this.getShopAptitude()
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        onChange(index) {
            this.index = index;
        },
        getShopAptitude(){
            this.$api.get('offshop/index/shop/detail/get/shop/aptitude',{id:this.$route.query.id}).then((res)=>{
                this.supermarketQualificationsList = res.list
                let name=[];
                for (let i in res.list){
                this.images.push(res.list[i].image[0])
                name.push(res.list[i].certificate_name);
                }
                this.typename=name
            });
        },
        magnify(index){
            this.images.map((res,i)=>{//指定初始位置
                if(i==index){
                    this.startPosition=i
                }
            })
            this.previewshow=true
        }
    }
}
</script>

<style lang="less">
.shade-watermark{
    pointer-events:none;
    position: fixed;
    top:44px;
    width: 100%;
    min-height: 100vh;
    background-image: url('../../assets/shared-hotel/watermark.png');
    background-size: 100% 100%;
}
.shade-watermarks{
    pointer-events:none;
    position: fixed;
    top:0;
    width: 100%;
    min-height: 100vh;
    background-image: url('../../assets/shared-hotel/watermark.png');
    background-size: 100% 100%;
}
.certifi-van-image{
.van-image-preview__index{
        position: absolute;
        left:0px;bottom:16px;
        top:auto;
        transform:none;
        box-sizing: border-box;
        display:flex;width:100%;
        .title,.page{
            display: inline-block;
            flex: 1;
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
        }
        .title{
            position: absolute;
            left:20px;
            bottom:0px;
        }
        .page{
            text-align: center;
            position: absolute;
            right:20px;
            bottom: 0px;
            label{
                font-size: 22px;
            }
            }
    }
    .image-preview-close-btn{
        position: absolute;
        right:20px;
        top:16px;
        color: #FFFFFF;
        text-align: right;
        font-size: 20px;
    }
    .van-image-preview__cover{
        position: absolute;
        right:20px;
        top:16px;
        color: #FFFFFF;
        text-align: right;
        font-size: 20px;
    }
}

    .qualifications-body {
        background: #ffffff;
        margin-top: 44px;
        .tips{
            font-size: 12px;
            color: #333333;
            padding: 20px 12px;
            box-sizing: border-box;
        }
        .qualifications-content{
            width:250px;
            margin:0 auto;
            padding-top: 15px;
            box-sizing: border-box;
            .qualifications-title{
                color: #333333;
                font-size: 13px;
                margin: 0 0 15px 0;
                text-align: center;
            }
        }
        .qualifications-contents{
            padding-top:60px;
        }
  }
</style>